import React from 'react'
import { useTranslation } from 'react-i18next'
import GameFeatures from './GameFeatures'
import WorkshopFeatures from './WorkshopFeatures'

function GameOverview() {
  const { t } = useTranslation()

  return (
    <div className="home">
      <div className="home__wrapper">
        <div className="home__title-container">
          <div className="home__title">{t('landing.game_overview.title')}</div>
        </div>
        <GameFeatures />
        <WorkshopFeatures />
      </div>
    </div>
  )
}

export default GameOverview
